/* A visible homepage entry into the installed photo-search upload flow. */
(() => {
  'use strict';
  if (document.documentElement.dataset.whPhotoSearchEntryBound) return;
  document.documentElement.dataset.whPhotoSearchEntryBound = 'true';

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wh-photo-upload]');
    if (!button) return;
    const section = button.closest('[data-wh-photo-search]');
    if (!section) return;
    event.preventDefault();

    const status = section.querySelector('[data-wh-photo-status]');
    const trigger = document.getElementById('snapseek-trigger');
    const overlay = document.getElementById('snapseek-overlay');
    const upload = document.getElementById('snapseek-upload-button');
    const input = document.getElementById('snapseek-file');
    const showUnavailable = () => {
      if (!status) return;
      status.textContent = 'Photo search is still loading. Please try again in a moment.';
      status.hidden = false;
    };

    if (!trigger || !overlay || !upload || !input) {
      showUnavailable();
      return;
    }
    trigger.click();
    if (!overlay.classList.contains('active')) {
      showUnavailable();
      return;
    }
    if (status) {
      status.textContent = '';
      status.hidden = true;
    }
    // Keep both clicks in the original user gesture so phone photo pickers can open.
    input.value = '';
    upload.click();
  });
})();
